import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35756dda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "double-range" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "double-range-slider py-4 mb-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "double-range-slider-track" }, null, -1))
const _hoisted_5 = {
  ref: "between",
  class: "double-range-slider-track-between"
}
const _hoisted_6 = ["value", "min", "max", "aria-valuenow", "aria-labelledby"]
const _hoisted_7 = ["value", "min", "max", "aria-valuenow", "aria-labelledby"]
const _hoisted_8 = { class: "double-range-values" }
const _hoisted_9 = {
  class: "value",
  "data-testid-lower-range": ""
}
const _hoisted_10 = {
  class: "value",
  "data-testid-higher-range": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tab_index = _resolveDirective("tab-index")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      id: _ctx.label,
      class: "double-range-label mb-3",
      "data-testid-label": ""
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, null, 512),
      _withDirectives(_createElementVNode("input", {
        value: _ctx.yearOne,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setyearOne($event.target.value))),
        type: "range",
        min: _ctx.minRange,
        max: _ctx.maxRange,
        "data-testid-input1": "",
        "aria-valuenow": _ctx.yearOne,
        "aria-labelledby": _ctx.label
      }, null, 40, _hoisted_6), [
        [_directive_tab_index, !_ctx.hidden]
      ]),
      _withDirectives(_createElementVNode("input", {
        value: _ctx.yearTwo,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setyearTwo($event.target.value))),
        type: "range",
        min: _ctx.minRange,
        max: _ctx.maxRange,
        "data-testid-input2": "",
        role: "slider",
        "aria-valuenow": _ctx.yearTwo,
        "aria-labelledby": _ctx.label
      }, null, 40, _hoisted_7), [
        [_directive_tab_index, !_ctx.hidden]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.lowerValue), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.higherValue), 1)
    ])
  ]))
}